


import React from 'react';

const PropertiesSection: React.FC = () => {
  const properties = [
    {
      id: 1,
      title: "Modern Greenwich Apartment",
      location: "Greenwich, CT",
      image: "https://static.readdy.ai/image/42b66528336391e6bad29f573a1eda9d/3e782ff9ed957a8e508c157538a7f078.jpeg",
      rating: 4.9,
      reviews: 45,
      airbnbUrl: "https://www.airbnb.com/slink/ufz1aROJ",
      description: "Stylish one-bedroom apartment in the heart of Greenwich. Features modern amenities, elegant furnishings, and convenient access to downtown attractions. Perfect for business travelers and couples seeking a sophisticated stay in Connecticut's premier town."
    },
    {
      id: 2,
      title: "Spacious Greenwich Family Home",
      location: "Greenwich, CT", 
      image: "https://static.readdy.ai/image/42b66528336391e6bad29f573a1eda9d/b0d6e1f0c2222bcfa89c6722a6404d5b.jpeg",
      rating: 4.8,
      reviews: 67,
      airbnbUrl: "https://www.airbnb.com/slink/yQ050MBx",
      description: "Beautiful four-bedroom home offering ample space for families and groups. This well-appointed property features comfortable living areas, fully equipped kitchen, and peaceful surroundings. Ideal for extended stays and family gatherings in prestigious Greenwich."
    },
    {
      id: 3,
      title: "Charming Old Greenwich Retreat",
      location: "Old Greenwich, CT",
      image: "https://static.readdy.ai/image/42b66528336391e6bad29f573a1eda9d/aaa9c62e22dc23ce9f9c7e4d6e484c47.jpeg",
      rating: 4.7,
      reviews: 52,
      airbnbUrl: "https://www.airbnb.com/l/ukHllU8h",
      description: "Cozy two-bedroom home nestled in historic Old Greenwich. This delightful property combines classic New England charm with modern conveniences. Close to the train station and local beaches, making it perfect for both leisure and business travelers."
    },
    {
      id: 4,
      title: "Contemporary Port Chester Home",
      location: "Port Chester, NY",
      image: "https://static.readdy.ai/image/42b66528336391e6bad29f573a1eda9d/370e481942c3abfea15495a14bd667bc.jpeg",
      rating: 4.7,
      reviews: 73,
      airbnbUrl: "https://www.airbnb.com/slink/Am7QZbch",
      description: "Modern three-bedroom home strategically located in Port Chester with easy access to NYC. Features contemporary design, comfortable accommodations, and excellent transportation links. Perfect for business travelers and families exploring the greater New York area."
    },
    {
      id: 5,
      title: "NYC Brownstone Apartment",
      location: "New York, NY",
      image: "https://static.readdy.ai/image/42b66528336391e6bad29f573a1eda9d/d765ff61ef0162ff412ae2166e653e28.jpeg",
      rating: 4.8,
      reviews: 156,
      airbnbUrl: "https://www.airbnb.com/slink/TFNgqmOY",
      description: "Well-located apartment in the heart of New York City. This comfortable space offers modern amenities and easy access to major attractions, restaurants, and transportation. Ideal for travelers wanting to experience the best of Manhattan with convenient home base."
    },
    {
      id: 6,
      title: "Executive Manila Suite",
      location: "Manila, Philippines",
      image: "https://static.readdy.ai/image/42b66528336391e6bad29f573a1eda9d/05a8a2e65c884fd89f130e3659a78846.jpeg",
      rating: 4.9,
      reviews: 89,
      airbnbUrl: "https://www.airbnb.com/slink/62nJmFYD",
      description: "Well-appointed suite located in Manila's sought-after business district with convenient access to commercial centers and transportation. This comfortable accommodation caters to business travelers and tourists seeking quality lodging in the Philippines' bustling capital city."
    }
  ];

  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Our Premium Properties
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Discover our carefully curated collection of exceptional rental properties, 
            each offering unique experiences and premium amenities for unforgettable stays.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {properties.map((property) => (
            <div key={property.id} className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300">
              <div className="relative h-64">
                <img
                  src={property.image}
                  alt={property.title}
                  className="w-full h-full object-cover object-top"
                />
                <div className="absolute top-4 right-4 bg-white px-3 py-1 rounded-full shadow-md">
                  <div className="flex items-center space-x-1">
                    <i className="ri-star-fill text-yellow-400 text-sm"></i>
                    <span className="text-sm font-semibold text-gray-900">{property.rating}</span>
                  </div>
                </div>
              </div>
              
              <div className="p-6">
                <div className="mb-3">
                  <h3 className="text-xl font-bold text-gray-900 leading-tight mb-2">
                    {property.title}
                  </h3>
                  <div className="flex items-center text-gray-600 mb-3">
                    <i className="ri-map-pin-line text-teal-600 mr-2"></i>
                    <span className="text-sm">{property.location}</span>
                  </div>
                </div>
                
                <p className="text-gray-600 text-sm leading-relaxed mb-4">
                  {property.description}
                </p>

                <div className="flex items-center justify-between">
                  <div className="flex items-center text-sm text-gray-500">
                    <i className="ri-star-fill text-yellow-400 mr-1"></i>
                    <span>{property.rating} rating</span>
                  </div>
                  <a
                    href={property.airbnbUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="bg-teal-600 text-white px-6 py-2 rounded-lg font-semibold hover:bg-teal-700 transition-colors duration-200 whitespace-nowrap cursor-pointer"
                  >
                    Book Now
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <div className="bg-gray-50 rounded-2xl p-8">
            <h3 className="text-2xl font-bold text-gray-900 mb-4">
              Ready to Experience Quality?
            </h3>
            <p className="text-gray-600 mb-6 max-w-2xl mx-auto">
              Each property is personally managed to ensure the highest standards of cleanliness, 
              comfort, and hospitality. Book directly through Airbnb for the best rates and instant confirmation.
            </p>
            <a
              href="https://www.airbnb.com/slink/ufz1aROJ"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center bg-teal-600 text-white px-8 py-3 rounded-lg font-semibold hover:bg-teal-700 transition-colors duration-200 cursor-pointer whitespace-nowrap"
            >
              <i className="ri-external-link-line mr-2"></i>
              View All on Airbnb
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PropertiesSection;


